import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  // Clave de 16 bytes (al igual que en tu código Java)
  private key = '@M4N_P*W3R_GR0UP'; // La clave debe tener 16 bytes

  // Método para encriptar con AES
  encrypt(password: string): string {
    const keyUtf8 = CryptoJS.enc.Utf8.parse(this.key);
    return CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(password), 
      keyUtf8,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    ).toString();
  }

  encryptToBase64(password: string): string {
    return this.encrypt(password);
  }
}
